import classes from './SectionList.module.sass'
// import { SectionItem } from './components/sectionItem/SectionItem'
// import courier from '../../../../../src/assets/images/courier.webp'
// import cargo from '../../../../../src/assets/images/cargo.webp'
// import truck from '../../../../../src/assets/images/truck.webp'

// import {
//   CARGO_FORM_ROUTE,
//   CARGO_MY_ROUTE,
//   CARGO_ROUTE,
//   CARGO_SELECTED_ROUTE,
//   SLOT_FORM_ROUTE,
//   SLOT_MY_ROUTE,
//   SLOT_ROUTE,
//   SLOT_SELECTED_ROUTE,
//   TRANSPORT_FORM_ROUTE,
//   TRANSPORT_MY_ROUTE,
//   TRANSPORT_ROUTE,
//   TRANSPORT_SELECTED_ROUTE,
// } from '../../../../common/utils/constants'
import { SalesSection } from './components/salesSection/SalesSection'

export const SectionList = () => {
  return (
    <div className={classes.Container}>
      <SalesSection />
      {/* <SectionItem
        title="Слоты"
        href={SLOT_ROUTE}
        image={courier}
        buttonText="Перейти"
        buttonText_2="Мои"
        buttonText_4="Избранное"
        href_2={SLOT_MY_ROUTE}
        buttonText_3="Добавить"
        href_3={SLOT_FORM_ROUTE}
        href_4={SLOT_SELECTED_ROUTE}
      />
      <SectionItem
        title="Транспорт"
        href={TRANSPORT_ROUTE}
        image={truck}
        buttonText="Перейти"
        buttonText_2="Мой"
        buttonText_4="Избранное"
        href_2={TRANSPORT_MY_ROUTE}
        buttonText_3="Добавить"
        href_3={TRANSPORT_FORM_ROUTE}
        href_4={TRANSPORT_SELECTED_ROUTE}
      />
      <SectionItem
        title="Грузы"
        href={CARGO_ROUTE}
        image={cargo}
        buttonText="Перейти"
        buttonText_2="Мои"
        buttonText_4="Избранное"
        href_2={CARGO_MY_ROUTE}
        buttonText_3="Добавить"
        href_3={CARGO_FORM_ROUTE}
        href_4={CARGO_SELECTED_ROUTE}
      /> */}
    </div>
  )
}
